module.exports = __webpack_public_path__ + "static/media/bg.8fc9f7bc.svg";